import { FC } from 'react';

export const DragHandleGlyph: FC = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="6" cy="4" r="1.3" fill="currentColor" />
    <circle cx="10" cy="4" r="1.3" fill="currentColor" />
    <circle cx="6" cy="8" r="1.3" fill="currentColor" />
    <circle cx="10" cy="8" r="1.3" fill="currentColor" />
    <circle cx="6" cy="12" r="1.3" fill="currentColor" />
    <circle cx="10" cy="12" r="1.3" fill="currentColor" />
  </svg>
);
